<app-survey-tests-edit
  *ngIf="editing"
  [survey_test]="survey_test"
  (saveEvent)="onSave($event)"
></app-survey-tests-edit>
<ng-container *ngIf="!editing">
  <div [clrLoading]="loading">
    <div *ngIf="survey_test">
      <!--  Header and actions -->
      <div
        class="clr-row"
        appPageHeader
        [title]="title"
        [actions]="actions"
        (clicks)="actionsHandler($event)"
      ></div>
      <app-record-subtitle
        [facility]="facility"
        [room]="room"
        [scanner]="scanner"
      ></app-record-subtitle>

      <div class="clr-row">
        <!-- Basic Info -->

        <!-- Questions -->
        <div class="clr-col-12" id="questions-display-container">
          <app-survey-test-details-questions
            [test]="survey_test"
          ></app-survey-test-details-questions>
        </div>

        <!-- Comments -->
        <div class="clr-col-12">
          <app-comments
            [scannerId]="scannerId"
            [surveyTestId]="survey_test.id"
          ></app-comments>
        </div>
      </div>
    </div>
  </div>
</ng-container>

